import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText } from '@wordpress/block-editor';
import { TextControl, SelectControl } from '@wordpress/components';
import apiFetch from '@wordpress/api-fetch';
import { useState, useEffect } from '@wordpress/element';
import metadata from './block.json';
import './editor.scss';

export default function Edit({attributes, setAttributes})  {	
	const blockProps	= useBlockProps();		
	const [ selectdata, setSelectdata ]	= useState("");
	
	//console.log('Attributes: ');
	//console.log(attributes.wordformid);
	//console.log(attributes);
	//console.log('attributes.wordformid: '+ attributes.wordformid );
	
	
	const getSelectedFormID	= (event) => {
		setAttributes( { ...attributes, wordformid: event.target.value } ); 
	}
	
	const getFormsdata = () => {
		useEffect(() => {
		let postID = wp.data.select("core/editor").getCurrentPostId();								
		apiFetch( {
			path: 'wordform/v1/all-form-list',
			method: 'POST',	
			data: { postID: postID },
		} ).then( ( res ) => {		   
			//console.log( res );
			const jData = JSON.parse(res);
			//console.log(jData);
			if ( jData.status == 'success' ) {
				setSelectdata(jData.formList);				
			}
			else {
				console.log('All forms list fetch error.');
			}
		} );		
			
		},[]);
	}
	
				
	useEffect(() => {		
		let postID = wp.data.select("core/editor").getCurrentPostId();
		//console.log('PostID: '+ postID );
		apiFetch( {
			path: 'wordform/v1/render-selected-form',
			method: 'POST',			
			data: { WordFormID: attributes.wordformid, postID: postID },
		} ).then( ( res ) => {		   
			//console.log( res );
			const jData = JSON.parse(res);
			//console.log(jData);
			if ( jData.status == 'success' ) {
				setAttributes( { ...attributes, createdformdata: jData.formdata } );
				//setAttributes( { createdformdata: jData.formdata, wordformid: formid } );
				//console.log(attributes.createdformdata);
			}
		} );		

	}, [attributes.wordformid]);			
							
    return (				
		<div {...blockProps}>		
        	{ getFormsdata() }		           
            <div className="sc-wordform-block-editor-form-selector-select-wrapper-div"> 
				<select onChange={getSelectedFormID} value={attributes.wordformid} className="sc-wordform-block-editor-form-selector-select">
				   <option value="">Select Form</option>
				   { selectdata && selectdata.map( (item) => <option key={item.ID} value={item.formID} selected={item.formID == attributes.wordformid}>
												  				{item.formName}
												             </option>
												 )}
				</select>
			</div>											 
		   
	        <div dangerouslySetInnerHTML={ { __html: attributes.createdformdata } }></div>
        						  
	    </div>
		
    );
}
